import { z } from 'zod';
import { ipv4OptionalPortRegex, ipv6OptionalPortRegex } from './helpers/ip-address.ts';
import { invalidPort } from './helpers/port.ts';

export const INVALID_HOST_OR_PORT = 'Invalid host or port';
export const INVALID_PORT_ERR = 'Invalid port';

/**
 * Check regex errors to see if we can be a bit more exact, and throw a port error message instead
 */
const errorMap: z.ZodErrorMap = (issue, ctx) => {
  if (issue.code === 'invalid_string' && issue.validation === 'regex') {
    if (invalidPort(ctx.data, ipv4OptionalPortRegex) || invalidPort(ctx.data, ipv6OptionalPortRegex)) {
      return { message: INVALID_PORT_ERR };
    }
    return { message: INVALID_HOST_OR_PORT };
  }
  return { message: ctx.defaultError };
};

const ipv6Schema = z
  .string({ errorMap })
  .regex(ipv6OptionalPortRegex)
  .refine((value) => !invalidPort(value, ipv6OptionalPortRegex), INVALID_PORT_ERR);

const ipv4Schema = z
  .string({ errorMap })
  .regex(ipv4OptionalPortRegex)
  .refine((value) => !invalidPort(value, ipv4OptionalPortRegex), INVALID_PORT_ERR);

/**
 * {@link IPAndPortSchema} takes in a string and validates that it is a valid ipv4/ipv6 address
 * with an optional port. It will also accept an empty string.
 */
export const IPAndPortSchema = z.union([ipv6Schema, ipv4Schema]).or(z.literal(''));
